// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".score-info-modal .score-info-modal__body{font-size:13px;line-height:1.5}.score-info-modal .score-info-modal__body p{margin-bottom:12px}.lbt-score.score-info-trigger,.lst-score-block.score-info-trigger{cursor:pointer}.lbt-score.score-info-trigger:hover,.lst-score-block.score-info-trigger:hover{filter:brightness(.96)}.lbt-score.score-info-trigger:focus-visible,.lst-score-block.score-info-trigger:focus-visible{outline:2px solid #0d6efd;outline-offset:1px}", ""]);
// Exports
module.exports = exports;
